import { UserAvatar } from "@/components/user/UserAvatar"
import { InlineEditableProperty } from "../../components/form/InlineEditableProperty"
import { QueryRender } from "../../components/helpers/QueryRender"
import { firstNameSchema, lastNameSchema, phoneSchema } from "../../entities/user/user"
import { useUpdateUser } from "../../entities/user/useUser"
import { useAuth } from "../../hooks/useAuth"
import { YoungContactsForm } from "@/components/user/YoungContactsForm"
import { formatPhoneNumber } from "@/utils/formatPhoneNumber"

export default function Settings() {
   const { user, ...query } = useAuth()
   const updateUser = useUpdateUser()

   const handlePropertySave = async (field: string, value: string) => {
      if (!user) return
      await updateUser(user.id, { [field]: value })
   }

   return (
      <div className="page-section max-w-xl">
         <h1 className="title">Paramètres</h1>
         <QueryRender query={query} data={user} emptyMessage="Utilisateur non trouvé">
            {(user) => (
               <>
                  <div className="flex items-center space-x-4 ">
                     <UserAvatar
                        photo={user.photo}
                        name={`${user.firstName} ${user.lastName}`}
                        size="xl"
                     />
                  </div>

                  <InlineEditableProperty
                     label="Email"
                     value={user?.email}
                     field="email"
                     editable={false}
                  />

                  <InlineEditableProperty
                     label="Prénom"
                     value={user?.firstName}
                     field="firstName"
                     schema={firstNameSchema}
                     onSave={handlePropertySave}
                  />

                  <InlineEditableProperty
                     label="Nom"
                     value={user?.lastName}
                     field="lastName"
                     schema={lastNameSchema}
                     onSave={handlePropertySave}
                  />

                  <InlineEditableProperty
                     label="Téléphone"
                     value={user?.phone}
                     field="phone"
                     schema={phoneSchema}
                     formatDisplayedValue={formatPhoneNumber}
                     onSave={handlePropertySave}
                  />

                  <InlineEditableProperty
                     label="Groupe"
                     value={user?.group}
                     field="group"
                     editable={false}
                  />

                  <YoungContactsForm user={user} onPropertySave={handlePropertySave} />

                  <div className="mb-6"></div>
               </>
            )}
         </QueryRender>
      </div>
   )
}
